"use strict";

exports.__esModule = true;
exports.default = functions;
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return a sorted list of the function names available on the object.
function functions(obj) {
  var names = [];
  for (var key in obj) {
    if ((0, _isFunction.default)(obj[key])) names.push(key);
  }
  return names.sort();
}